import { render } from "./ContactInformationForm.vue?vue&type=template&id=dc4e36fa&scoped=true"
import script from "./ContactInformationForm.vue?vue&type=script&lang=js"
export * from "./ContactInformationForm.vue?vue&type=script&lang=js"

import "./ContactInformationForm.vue?vue&type=style&index=0&id=dc4e36fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dc4e36fa"]])

export default __exports__